import React from "react";
import styled from "styled-components";
import { Colors } from "../../../config";

const FlightDataHeaderWrapper = ({ category, rating }) => {
  return (
    <StyledFlightDataHeaderWrapper>
      <FlightDataHeader>
        <FilteredEntity>{category}</FilteredEntity>
        <Rating>
          Rating: <span>{rating}</span>
        </Rating>
      </FlightDataHeader>
    </StyledFlightDataHeaderWrapper>
  );
};

const StyledFlightDataHeaderWrapper = styled.div`
  border-bottom: 1px solid ${Colors.sharkOpacity10};
  font-size: 0.7rem;
  font-weight: 600;
`;
const FlightDataHeader = styled.div`
  padding: 1rem;
  display: flex;
`;

const FilteredEntity = styled.div`
  padding-right: 1rem;
  color: ${Colors.martiniqueOpacity90};
`;

const Rating = styled.div`
  padding: 0 1rem;
  color: ${Colors.martiniqueOpacity90};
  border-left: 1px solid ${Colors.sharkOpacity30};
  > span {
    color: ${Colors.orange};
  }
`;

export default FlightDataHeaderWrapper;
